import { render } from "./SvgImg.vue?vue&type=template&id=2dc74dd4"
import script from "./SvgImg.vue?vue&type=script&lang=js"
export * from "./SvgImg.vue?vue&type=script&lang=js"
script.render = render

export default script